module.exports = __webpack_public_path__ + "static/705c0396af3561470fd5867569ff0622b6e9c35ff12f9ab33c8e47a57bc55198-8735a4d9b86717afb04730e2f6662869.png";